import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Teleport as _Teleport, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "SiteWrapperStudySearch js-searchContainer" }
const _hoisted_2 = { class: "mdc-layout-grid GridInContainer" }
const _hoisted_3 = { class: "mdc-layout-grid__inner" }
const _hoisted_4 = { class: "mdc-layout-grid__cell mdc-layout-grid__cell--span-12" }
const _hoisted_5 = { class: "AsideDesktopContainer" }
const _hoisted_6 = { class: "MainContainer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FilterContainer = _resolveComponent("FilterContainer")
  const _component_MetaInfo = _resolveComponent("MetaInfo")
  const _component_NavigationBar = _resolveComponent("NavigationBar")
  const _component_SearchBar = _resolveComponent("SearchBar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_ErrorPage = _resolveComponent("ErrorPage")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(['ContainerWrapper', {'has-static-content': _ctx.hasStaticContent}])
          }, [
            _createElementVNode("aside", _hoisted_5, [
              (!_ctx.isMobile)
                ? (_openBlock(), _createBlock(_component_FilterContainer, { key: 0 }))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("article", _hoisted_6, [
              (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
                _createVNode(_component_MetaInfo)
              ])),
              _createVNode(_component_NavigationBar),
              _createVNode(_component_SearchBar),
              _createVNode(_component_router_view),
              (_ctx.isApplicationStatusError)
                ? (_openBlock(), _createBlock(_component_ErrorPage, { key: 0 }))
                : _createCommentVNode("v-if", true)
            ])
          ], 2 /* CLASS */)
        ])
      ])
    ])
  ]))
}